var _path, _path2, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemBgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 412,
    viewBox: "0 0 430 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_2503_650)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.791 288.064H73L214.059 75L370.791 288.064Z",
    fill: "url(#paint0_linear_2503_650)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter1_f_2503_650)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.791 123.594H73L214.059 336.657L370.791 123.594Z",
    fill: "url(#paint1_linear_2503_650)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2503_650)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 198,
    r: 82.5,
    stroke: "url(#paint2_linear_2503_650)",
    strokeWidth: 5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 198,
    r: 84.5,
    stroke: "url(#paint3_linear_2503_650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2503_650",
    x: -1.75917,
    y: 0.240829,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2503_650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2503_650",
    x: -1.75917,
    y: 48.8343,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2503_650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2503_650",
    x: 124,
    y: 107,
    width: 182,
    height: 182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_2503_650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2503_650",
    x1: 221.895,
    y1: 75,
    x2: 221.895,
    y2: 288.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2503_650",
    x1: 221.895,
    y1: 336.657,
    x2: 221.895,
    y2: 123.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2503_650",
    x1: 215,
    y1: 113,
    x2: 215,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2503_650",
    x1: 215,
    y1: 113,
    x2: 215,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemBgLocked);
export default __webpack_public_path__ + "static/media/gem-bg-locked.9195bc2d8be1f799644a4677799d3e2e.svg";
export { ForwardRef as ReactComponent };